import { render, staticRenderFns } from "./VehicleOperLog.vue?vue&type=template&id=04783b48&scoped=true"
import script from "./VehicleOperLog.vue?vue&type=script&lang=js"
export * from "./VehicleOperLog.vue?vue&type=script&lang=js"
import style0 from "./VehicleOperLog.vue?vue&type=style&index=0&id=04783b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04783b48",
  null
  
)

export default component.exports